// src/components/PaymentButton.jsx
// Unified payment button — supports both Paystack and Flutterwave
// Set REACT_APP_PAYMENT_GATEWAY=flutterwave or paystack in .env

import { useState } from "react";
import { initiatePaystackPayment }    from "../hooks/usePaystack";
import { initiateKorapayPayment }     from "../hooks/useKorapay";

// Which gateway to use — defaults to korapay
const GATEWAY = process.env.REACT_APP_PAYMENT_GATEWAY || "korapay";

const GATEWAY_LABELS = {
  korapay: {
    name:  "Korapay",
    color: "#000000",
    icon:  "💳",
    note:  "Cards, Bank Transfer & USSD accepted",
  },
  paystack: {
    name:  "Paystack",
    color: "#00C3F7",
    icon:  "🔒",
    note:  "Cards, Bank Transfer & USSD accepted",
  },
};

export default function PaymentButton({
  email, uid, name, phone = "",
  onSuccess, onClose,
  label   = "Pay ₦250 — Activate Membership",
  disabled = false,
  style    = {},
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  const gateway = GATEWAY_LABELS[GATEWAY] || GATEWAY_LABELS.flutterwave;

  const handlePay = async () => {
    setError("");
    setLoading(true);

    const options = {
      email, uid, name, phone,
      onSuccess: (response) => {
        setLoading(false);
        onSuccess?.(response);
      },
      onClose: () => {
        setLoading(false);
        onClose?.();
      },
      onError: (msg) => {
        setLoading(false);
        setError(msg);
      },
    };

    if (GATEWAY === "paystack") {
      await initiatePaystackPayment(options);
    } else {
      await initiateKorapayPayment(options);
    }
  };

  return (
    <div>
      {error && (
        <div style={{
          background: "rgba(239,68,68,0.08)",
          border: "1px solid rgba(239,68,68,0.2)",
          borderRadius: 4, padding: "12px 16px",
          fontSize: 13, color: "#dc2626",
          marginBottom: 14, lineHeight: 1.6,
        }}>
          ⚠️ {error}
        </div>
      )}

      <button
        onClick={handlePay}
        disabled={disabled || loading}
        className="btn-primary"
        style={{
          width: "100%", padding: "16px",
          fontSize: 15, display: "flex",
          alignItems: "center", justifyContent: "center", gap: 10,
          ...style,
        }}
      >
        {loading ? (
          <>
            <span style={{
              width: 18, height: 18,
              border: "2px solid rgba(11,31,58,0.2)",
              borderTopColor: "#0B1F3A",
              borderRadius: "50%",
              animation: "spin 0.6s linear infinite",
              display: "inline-block", flexShrink: 0,
            }} />
            Processing payment...
          </>
        ) : (
          <>
            <span>{gateway.icon}</span>
            {label}
          </>
        )}
      </button>

      {/* GATEWAY INFO */}
      <div style={{
        marginTop: 12, padding: "12px 16px",
        background: "var(--off-white)",
        borderRadius: 4, textAlign: "center",
      }}>
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginBottom: 4 }}>
          {gateway.note}
        </div>
        <div style={{ fontSize: 11, color: "var(--text-muted)", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
          <span>🔒</span>
          <span>Secured by <strong style={{ color: "var(--navy)" }}>{gateway.name}</strong> · SSL Encrypted · Your card details are never stored</span>
        </div>
      </div>
    </div>
  );
}
